<template>
  <loading
    :active="isLoadingModel"
    :can-cancel="true"
    color="var(--primary-color)"
    :is-full-page="fullPage"
  ></loading>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <DataTable
          
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5><b>Manage User Master</b></h5>
              <div class="flex align-items-center gap-3">
                <Button
                  label="New"
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-success"
                  v-tooltip.bottom="'Add role'"
                  @click="openNew"
                />
                <Button
                  icon="pi pi-upload"
                  class="p-button-rounded p-button-help"
                  v-tooltip.bottom="'Export CSV'"
                  @click="exportCSV($event)"
                />
                <span>Total : {{ totalRecords }}</span>
              </div>
            </div>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3"
            >
              <!-- Filters Section -->
              <div class="flex flex-wrap gap-3">
                <!-- Name Filter -->
                <div class="field w-auto">
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      v-model="search_name"
                      v-tooltip.bottom="'search'"
                    />
                    <label for="name">Search</label>
                  </span>
                </div>
                <Button
                  icon="pi pi-search"
                  @click="search(1)"
                  class="p-button-rounded p-button-primary"
                  v-tooltip.bottom="'Search'"
                />
                <Button
                  icon="pi pi-refresh"
                  class="p-button-rounded p-button-danger"
                  v-tooltip.bottom="'Refresh'"
                  @click="search(2)"
                />
              </div>
            </div>
          </template>
          <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> -->
          <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
          <Column header="Edit" style="max-width: 5rem" frozen>
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-primary"
                @click="editProduct(slotProps.data)"
              />
              <!-- <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
              /> -->
            </template>
          </Column>
          <Column
            header="Status"
            style="max-width: 5rem"
            :field="columns[14]"
          
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge :value="data.status" severity="success"></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge :value="data.status" severity="warning"></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge :value="data.status" severity="danger"></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column
            header="Sr No"
            style="max-width: 3rem"
            frozen
          >
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column
            header="Name"
            style="min-width: 5rem"
            :field="columns[1]"
            frozen
          >
            <template #body="{ data }">
              {{ data.name }}
            </template>
          </Column>
        
          <Column
            header="City Village"
            :field="columns[8]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.citY_VILLAGE }}
            </template>
          </Column>
          <Column
            header="Pincode"
            :field="columns[12]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.pincode }}
            </template>
          </Column>
          <Column header="Mobile" style="min-width: 5rem" :field="columns[9]" >
            <template #body="{ data }">
              {{ data.mobile }}
            </template>
          </Column>
          <Column header="Email" style="min-width: 5rem" :field="columns[10]">
            <template #body="{ data }">
              {{ data.email }}
            </template>
          </Column>
          
        </DataTable>
        <Dialog
          v-model:visible="productDialog"
          :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '60vw' }"
          header="Profile Details"
          :modal="true"
          position="top"
        >
          <div class="col-12">
            <div class="p-fluid formgrid grid" style="margin-top: 2%">
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="name"
                    type="text"
                    v-model="product.name"
                    v-tooltip.bottom="'Full Name'"
                    :class="{ 'p-invalid': submitted && !product.name }"
                  />
                  <label for="name">Name</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="email"
                    type="text"
                    v-model="product.email"
                    v-tooltip.bottom="'Email'"
                    :class="{ 'p-invalid': submitted && !product.email }"
                  />
                  <label for="email">Email</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="mobile_no"
                    type="number"
                    v-model="product.mobile"
                    v-tooltip.bottom="'Mobile number'"
                    :class="{ 'p-invalid': submitted && !product.mobile }"
                  />
                  <label for="mobile_no">Mobile</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="password"
                    type="password"
                    v-model="product.password"
                    v-tooltip.bottom="'Password'"
                    :class="{ 'p-invalid': submitted && !product.password }"
                  />
                  <label for="pasword">Password</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="state"
                    type="text"
                    v-model="product.state"
                    v-tooltip.bottom="'State'"
                    :class="{ 'p-invalid': submitted && !product.state }"
                  />
                  <label for="state">State</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <Textarea
                    id="address"
                    type="text"
                    v-model="product.address"
                    v-tooltip.bottom="'Address'"
                    :class="{ 'p-invalid': submitted && !product.address }"
                  />
                  <label for="address">Address</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="city_village"
                    type="text"
                    v-model="product.citY_VILLAGE"
                    v-tooltip.bottom="'City or Vilage'"
                    :class="{ 'p-invalid': submitted && !product.citY_VILLAGE }"
                  />
                  <label for="city_village">City Or Village</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="taluka"
                    type="text"
                    v-model="product.taluka"
                    v-tooltip.bottom="'Taluka'"
                    :class="{ 'p-invalid': submitted && !product.taluka }"
                  />
                  <label for="taluka">Taluka</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="district"
                    type="text"
                    v-model="product.district"
                    v-tooltip.bottom="'District'"
                    :class="{ 'p-invalid': submitted && !product.district }"
                  />
                  <label for="district">District</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="pincode"
                    type="number"
                    v-model="product.pincode"
                    v-tooltip.bottom="'Pincode'"
                    :class="{ 'p-invalid': submitted && !product.pincode }"
                  />
                  <label for="pincode">Pincode</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status"
                    :options="status_dropdownItems"
                    optionLabel="name"
                    filter
                    :class="{ 'p-invalid': submitted && !status }"
                  ></Dropdown>
                  <label for="status">Status</label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="user_role"
                    :options="role_dropdown"
                    optionLabel="user_role_name"
                    filter
                    :class="{ 'p-invalid': submitted && !user_role }"
                  ></Dropdown>
                  <label for="status">Role</label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <FileUpload
                  class="p-button-primary"
                  mode="basic"
                  name="profilE_PHOTO"
                  :auto="true"
                  :custom-upload="true"
                  chooseLabel="Profile Photo"
                  @uploader="handleFileUpload"
                />
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <img
                  :src="profilE_PHOTO"
                  :alt="profilE_PHOTO"
                  v-if="profilE_PHOTO"
                  class="shadow-2"
                  width="70"
                />
                <img
                  v-else
                  src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                  class="shadow-2"
                  width="70"
                />
              </div>
            </div>
          </div>
          <template #footer>
            <Button
              v-if="product.uid"
              label="UPDATE"
              icon="pi pi-check"
              class="p-button-success mr-1 mb-1"
              @click="adduser"
            />
            <Button
              v-else
              label="ADD"
              icon="pi pi-check"
              class="p-button-success mr-1 mb-1"
              @click="adduser"
            />
            <!-- <Button label="Save" @click="updateUser" icon="pi pi-check" class="p-button-success"/> -->
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger mr-1 mb-1"
              @click="productDialog = false"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";
// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      // dropdownItems: [
      //   { name: "Motivational", value: "Motivational" },
      //   { name: "Interview", value: "Interview" },
      // ],
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      status: null,
      role_dropdown: [],
      user_role: null,
      profilE_PHOTO: "",
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: { name: "", value: "" },
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
    this.getRoleList();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    //a simple date formatting function
    dateFormat(inputDate, info) {},
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async search(count) {
      if (count == 2) {
        this.search_name = "";
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        //id: localStorage.getItem("id"),
        Limit: this.limit,
        page_no: this.page_no,
        count: true,
        Name: this.search_name,
      };
     // this.loading = true;
      var promise = apis.PwdUserList(data, this.id);
      promise.then((response) => {
       // this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        Limit: this.limit,
        page_no: this.page_no,
        count: false,
        Name: this.search_name,
      };
      this.loading = true;
      var promise = apis.PwdUserList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    getRoleList() {
      var data = {
        Limit: this.limit,
        page_no: this.page_no,
        count: false,
      };
      var promise = apis.RoleList(data);
      promise.then((response) => {
        // if(response.data.data){
        // response.data.data
        //   .filter(item => item.client_name)
        //   .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
        // }
        this.role_dropdown = response.data.data;
        console.log("data", this.role_dropdown);
      });
    },
    async handleFileUpload(event) {
      if (!event.files || event.files.length === 0) {
        console.error("No file selected");
        return;
      }
      var fileUp = event.files[0]; // Correctly access the file
      var filetype = fileUp.type;
      // Validate only image files
      if (!filetype.startsWith("image/")) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please select only an image file.",
          life: 3000,
        });
        return false;
      }
      var filepath = "CMRF/" + fileUp.name;
      var file = fileUp;
      var data = {
        filePath: filepath,
        contentType: filetype,
      };
      try {
        // Upload to AWS
        let response = await apis.upload_to_AWS(data);
        let signedUrl = response.data.url;
        var uploadOptions = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": filetype,
          },
        };
        await axios.put(signedUrl, file, uploadOptions);
        // Set the profile photo URL
        this.profilE_PHOTO = `https://edukatta-docs.s3.ap-south-1.amazonaws.com/${filepath}`;
      } catch (error) {
        console.error("File upload failed:", error);
      }
    },
    // formatCurrency(value) {
    //   if (value)
    //     return value.toLocaleString("en-US", {
    //       style: "currency",
    //       currency: "USD",
    //     });
    //   return;
    // },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async adduser() {
      this.submitted = true;
      // if (!this.selectstatus.value) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Select Status",
      //     life: 3000,
      //   });
      //   return false;
      // }
      if (!this.product.name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Name",
          life: 3000,
        });
        return false;
      }
      // if (!this.product.middeL_NAME) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Middle Name",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.surname) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter LastName",
      //     life: 3000,
      //   });
      //   return false;
      // }
      //  if (!this.product.aadhaR_CARD) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Adhar No",
      //     life: 3000,
      //   });
      //   return false;
      // }
      if (!this.product.state) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter State",
          life: 3000,
        });
        return false;
      }
      if (!this.product.district) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter District",
          life: 3000,
        });
        return false;
      }
      if (!this.product.taluka) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Taluka",
          life: 3000,
        });
        return false;
      }
      if (!this.product.citY_VILLAGE) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter city/village",
          life: 3000,
        });
        return false;
      }
      if (!this.product.pincode) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Pincode",
          life: 3000,
        });
        return false;
      }
      if (!this.product.address) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter address",
          life: 3000,
        });
        return false;
      }
      if (!this.product.mobile) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter mobile",
          life: 3000,
        });
        return false;
      }
      if (!this.product.email) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter email",
          life: 3000,
        });
        return false;
      }
      var emailreg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
      if (this.product.email) {
        if (emailreg.test(this.product.email) == false) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please enter valid email",
            life: 3000,
          });
          return false;
        }
      }
      const phoneRegex = /^[0-9]{10}$/;
      if (this.product.mobile && !phoneRegex.test(this.product.mobile)) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Valid mobile",
          life: 3000,
        });
        return false;
      }
      if (!this.product.password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Password",
          life: 3000,
        });
        return false;
      }
      var password_reg =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
      if (this.product.password && !password_reg.test(this.product.password)) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Valid Password",
          life: 3000,
        });
        return false;
      }
      // console.log("uid",this.product.uid);
      //edit
      if (this.product.uid) {
        this.product.status = this.status.value;
        this.product.user_role_id = this.user_role
          ? this.user_role.user_role_id
          : null;
        this.product.user_role_name = this.user_role
          ? this.user_role.user_role_name
          : null;
        var data1 = {
          uid: this.product.uid,
          name: this.product.name,
          address: this.product.address,
          state: this.product.state,
          district: this.product.district,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: this.product.mobile,
          email: this.product.email,
          pincode: this.product.pincode,
          status: this.product.status,
          user_role_id: this.product.user_role_id,
          user_role_name: this.product.user_role_name,
          password: this.product.password,
          profilE_PHOTO: this.profilE_PHOTO,
          clientid: 1,
          updateD_BY: localStorage.getItem("user_key"),
        };
        this.isLoadingModel = true;
        var promise = apis.InsertUpdatePwd(data1);
        promise
          .then((responseapi) => {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              width: 350,
              text: responseapi.data.message,
            });
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              width: 350,
              text: error.responseapi?.data?.message,
            });
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        this.product.status = this.status.value;
        this.product.user_role_id = this.user_role
          ? this.user_role.user_role_id
          : null;
        this.product.user_role_name = this.user_role
          ? this.user_role.user_role_name
          : null;
        var data = {
          name: this.product.name,
          address: this.product.address,
          state: this.product.state,
          district: this.product.district,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: this.product.mobile,
          email: this.product.email,
          password: this.product.password,
          profilE_PHOTO: this.profilE_PHOTO,
          pincode: this.product.pincode,
          status: this.product.status,
          user_role_id: this.product.user_role_id,
          user_role_name: this.product.user_role_name,
          clientid: 1,
          createD_BY: localStorage.getItem("user_key"),
        };
        this.isLoadingModel = true;
        var promises = apis.InsertUpdatePwd(data);
        promises
          .then((responseapi) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire({
              icon: "success",
              title: "Success",
              width: 350,
              text: responseapi.data.message,
            });
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              width: 350,
              text: error.responseapi?.data?.message,
            });
            this.get_list();
            this.get_count();
          });
      }
      this.selectstatus = { name: "", value: "" };
      //  this.selectstatus2={name:"",value:""}
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.name.trim()) {
        if (this.product.id) {
          this.product.inventoryStatus = this.product.inventoryStatus.value
            ? this.product.inventoryStatus.value
            : this.product.inventoryStatus;
          this.products[this.findIndexById(this.product.id)] = this.product;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          this.product.id = this.createId();
          this.product.code = this.createId();
          this.product.image = "product-placeholder.svg";
          this.product.inventoryStatus = this.product.inventoryStatus
            ? this.product.inventoryStatus.value
            : "INSTOCK";
          this.products.push(this.product);
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        this.productDialog = false;
        this.product = {};
      }
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      // this.selectstatus.value = this.product.status;
      // this.selectstatus.name = this.product.status;
      this.profilE_PHOTO = product.profilE_PHOTO || "";
      this.status =
        this.status_dropdownItems.find(
          (item) => item.value === product.status
        ) || null;
      this.user_role =
        this.role_dropdown.find(
          (item) => item.user_role_id === product.user_role_id
        ) || null;
      // this.selectstatus2.value = this.product.status;
      // this.selectstatus2.name = this.product.status;
      // this.file_attachment = this.product.image;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },
    deleteuser() {
      if (this.product.admiN_ID) {
        var data = {
          Admin_id: this.product.admiN_ID,
        };
        this.isLoadingModel = true;
        var promise = apis.deleteusermaster(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Video");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
